var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrapper",
    "class": {
      'p-0 freq': _vm.noInput
    },
    attrs: {
      "id": _vm.id
    },
    on: {
      "click": function click($event) {
        _vm.$refs['dropdown-' + _vm.id].open = true;
      }
    }
  }, [_vm.name ? _c('div', {
    staticClass: "field-label dropdown",
    "class": {
      'd-none': _vm.nameShort
    }
  }, [_vm._v(" " + _vm._s(_vm.name) + " ")]) : _vm._e(), _c('div', {
    staticClass: "select-wrapper vselect-required-wrap",
    "class": {
      'select-wrapper-normal': _vm.normal
    }
  }, [_vm.required ? _c('input', {
    staticClass: "vselect-required-overlay",
    attrs: {
      "type": "text",
      "required": "",
      "tabindex": "-1",
      "aria-hidden": "true",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.requiredProxyValue
    }
  }) : _vm._e(), _c('vue-select', {
    ref: 'dropdown-' + _vm.id,
    staticClass: "select",
    attrs: {
      "name": _vm.name,
      "taggable": _vm.taggable,
      "label": "display_name",
      "options": _vm.options,
      "multiple": _vm.multiple
    },
    on: {
      "option:selected": _vm.removeLabel
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }